// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M23.2579 20.5H0.741211L11.9995 1L23.2579 20.5ZM12.9992 12.5316V9H10.9992V12.5316L7.59082 15.372L8.87119 16.9084L11.9992 14.3017L15.1273 16.9084L16.4076 15.372L12.9992 12.5316Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-coordinate-system-filled')
export default class CoordinateSystemFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'coordinate-system-filled',
    }
  }
}
